{
  "version": 1,
  "asset_id": "1590f15c-050a-4f22-bf2c-c5a94c22a9e5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/1590f15c-050a-4f22-bf2c-c5a94c22a9e5/sleeve-hiatal-type-1-second-es-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/1590f15c-050a-4f22-bf2c-c5a94c22a9e5/sleeve-hiatal-type-1-second-es-800.jpg",
  "original_filename": "sleeve-hiatal-type-1-second-es-800.jpg",
  "size": 97563,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T22:32:06Z"
}
